// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__2wBq9","body":"Accordion_body__3Gjl-","heading":"Accordion_heading__2X6e9"};